// Авто Техподдержка: обращения кабинета в поддержку Ozon и задания роботу.
const base = (accountId) => `account_id=${encodeURIComponent(accountId)}`;

export const loadSupportTickets = ({ request, accountId, state = 'active', limit = 50, offset = 0 }) =>
  request(`/api/v1/support-auto/tickets?${base(accountId)}&state=${state}&limit=${limit}&offset=${offset}`);

export const loadSupportTicket = ({ request, ticketId }) =>
  request(`/api/v1/support-auto/tickets/${ticketId}`);

export const loadSupportJobs = ({ request, accountId }) =>
  request(`/api/v1/support-auto/jobs?${base(accountId)}`);

export const createSupportJob = ({ request, accountId, job }) =>
  request(`/api/v1/support-auto/jobs?${base(accountId)}`, { method: 'POST', body: JSON.stringify(job) });

export const updateSupportJob = ({ request, jobId, job }) =>
  request(`/api/v1/support-auto/jobs/${jobId}`, { method: 'PUT', body: JSON.stringify(job) });

export const pauseSupportJob = ({ request, jobId }) =>
  request(`/api/v1/support-auto/jobs/${jobId}/pause`, { method: 'POST' });

export const resumeSupportJob = ({ request, jobId }) =>
  request(`/api/v1/support-auto/jobs/${jobId}/resume`, { method: 'POST' });

export const answerSupportQuestion = ({ request, jobId, questionId, answer }) =>
  request(`/api/v1/support-auto/jobs/${jobId}/answer?question_id=${questionId}`, { method: 'POST', body: JSON.stringify({ answer }) });

export const reviveSupportTicket = ({ request, ticketId }) =>
  request(`/api/v1/support-auto/tickets/${ticketId}/revive`, { method: 'POST' });

export const readSupportTicket = ({ request, ticketId }) =>
  request(`/api/v1/support-auto/tickets/${ticketId}/read`, { method: 'POST' });

export const syncAllSupportTickets = ({ request, accountId, since }) =>
  request(`/api/v1/support-auto/sync-all?${base(accountId)}${since ? `&since=${since}` : ''}`, { method: 'POST' });

export const refreshSupportTickets = ({ request, accountId }) =>
  request(`/api/v1/support-auto/refresh?${base(accountId)}`, { method: 'POST' });

export const JOB_STATE_LABELS = {
  active: 'Робот работает',
  waiting_user: 'Ждёт вашего ответа',
  resolved: 'Решено',
  paused: 'На паузе',
  failed: 'Остановлено',
};

export const JOB_ERROR_LABELS = {
  insufficient_balance: 'Недостаточно средств у плательщика',
  payer_not_set: 'У кабинета не указан плательщик',
  not_configured: 'ИИ не настроен на сервере',
  account_not_ready: 'У кабинета не указан Seller ID',
  bad_decision: 'ИИ вернул непонятный ответ, повторим позже',
  send_failed: 'Не удалось отправить сообщение в обращение',
  ticket_closed: 'Обращение закрыто',
  limit_reached: 'Достигнут дневной лимит сообщений',
};
